module.exports = __webpack_public_path__ + "img/Number=60.41f1081c.png";